import React from 'react';
import {asyncComponent} from 'react-async-component';

export const AsyncReviews = asyncComponent({
    resolve: () => import(
        /* webpackChunkName: "unit-reviews" */
        /* webpackPreload: true */
        './Reviews'
    ),
    LoadingComponent: () => <span />,
    serverMode: 'defer'
});
